<template>
  <section v-if="result" v-show="isOpen" class="top-message-banner">
    <div class="banner-container">
      <DefButtonCross v-if="isClosable" @click="handlerClose" />
    </div>
    <DefSlider :settings="settings" :priority="true">
      <a
        v-for="item in result"
        :key="item.id"
        class="swiper-slide top-message-banner-item"
        :data-swiper-autoplay="+item.timeout * 1000 || 5000"
        :style="{ '--banner-color': item?.colorRGB ?? '#E20712' }"
        :href="item.link"
      >
        <span v-html="item.previewText"></span>
      </a>
    </DefSlider>
  </section>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import DefSlider from '@components/Def/DefSlider/DefSlider.vue';
import { EffectFade, Autoplay } from 'swiper/modules';
import DefButtonCross from '@components/Def/DefButtonCross/DefButtonCross.vue';

const props = defineProps(['result']);

const settings = {
  slidesPerView: 1,
  spaceBetween: 16,
  effect: 'fade',
  modules: [EffectFade, Autoplay],
  autoplay: true,
};

// баннер для чёрного списка показывается всегда, закрыть его нельзя
const isClosable = computed(() => !props.result?.some((item) => item.code === 'blacklist'));

const isOpen = ref(true);
const handlerClose = () => {
  isOpen.value = false;
  const sevenDays = 1000 * 60 * 60 * 24 * 7;
  const expires = new Date(Date.now() + sevenDays);
  document.cookie = `hide_top_banner=true; path=/; expires=${expires}`;
};
</script>

<style lang="scss" scoped>
.top-message-banner {
  position: relative;
  :deep(.def-slider__container) {
    margin-bottom: 0;
  }
  :deep(.def-button-cross) {
    position: absolute;
    top: 9px;
    z-index: 2;
    width: 20px;
    height: 20px;
    right: $gap-mobile;
    @include point-md {
      right: $gap-tablet;
    }
    @include point-lg {
      right: $gap;
    }
  }
}
.top-message-banner-item {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 36px;
  padding: 0 44px 0 20px;
  text-align: center;
  background-color: var(--banner-color);
  font-weight: 500;
  line-height: 125%;
  font-size: 14px;
  @include point-md {
    font-size: 16px;
  }
}
.banner-container {
  position: relative;
  margin-left: auto;
  margin-right: auto;
  max-width: $main-width;
  width: 100%;
}
</style>
